<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Womens Grievance Redressal Committee</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Womens Grievance Redressal Committee</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="minority-cell ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table--4">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Name of the member</th>
                <th>Role in Committee</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Prof. Kulthe Sarika</td>
                <td>Chairman</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Prof. Cheena Kabra</td>
                <td>Teaching Representative</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Prof.Paramela Jogadande</td>
                <td>Teaching Representative</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Ms. Neha Kale</td>
                <td>Student Representative (BBA(CA))</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Ms. Vaishnavi Dhaytadak</td>
                <td>Student Representative (B. Sc(CS))</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Ms. Sheetal Chavan</td>
                <td>Student Representative (B.Com)</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Mr. Anagha Shitole</td>
                <td>Student Representative (BBA)</td>
              </tr>
            </tbody>
          </table>
          <!-- <table class="table table-bordered table-striped table--4">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Name of the member</th>
                  <th>Role in Committee</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Prof. Kulthe Sarika</td>
                  <td>Chairman</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Prof. Mohini Pardeshi </td>
                  <td>Teaching Representative</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Prof. Prafulla Jadhav</td>
                  <td>Teaching Representative</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Ms. Neha Kale</td>
                  <td>Student Representative(BBA(CA))</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>Mr. Dnyanesh Gote</td>
                  <td>Student Representative(B. Sc(CS))</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>Ms. Sheetal Chavan</td>
                  <td>Student Representative(B.Com)</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>Mr. Arkaj Bhot</td>
                  <td>Student Representative(BBA)</td>
                </tr>
              </tbody>
            </table> -->
        </div>
      </div>
    </div>
  </div>
</section>
